export enum AlertStatus {
  Success = 1,
  Fail = 2
}
